import { allFields, validateField } from './utils';

export const ACTIONS = {
  UPDATE_FIELD_VALUE: 'UPDATE_FIELD_VALUE',
  UPDATE_FIELD_ERRORS: 'UPDATE_FIELD_ERRORS',
  UPDATE_FORM_ERRORS: 'UPDATE_FORM_ERRORS',
  UPDATE_FORM_VALUES: 'UPDATE_FORM_VALUES',
}

export const newPasswordReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.UPDATE_FIELD_VALUE: {
      const { field, value } = action.payload;
      const updatedState = { ...state, [field]: { ...state[field], value } };
      return updatedState;
    }

    case ACTIONS.UPDATE_FIELD_ERRORS: {
      const { field, intl, regexPolicy } = action.payload;
      return {
        ...state,
        [field]: {
          ...state[field],
          errors: validateField({
            state,
            field,
            value: state[field].value,
            intl,
            regexPolicy,
          }),
        },
      };
    }
    case ACTIONS.UPDATE_FORM_ERRORS: {
      return action.payload.reduce((acc, curr) => {
        acc[curr.field] = { value: curr.value, errors: curr.errors }
        return acc;
      }, {});
    }

    case ACTIONS.UPDATE_FORM_VALUES: {
      const { data, intl, regexPolicy } = action.payload;
      const updatedState = { ...state };

      allFields.forEach(field => {
        if (data[field]) {
          updatedState[field].value = data[field]
        }
      });

      allFields.forEach(field => {
        if (data[field]) {
          updatedState[field].errors = validateField({
            field, value: data[field], state: updatedState, intl, regexPolicy,
          });
        }
      });
      return updatedState;
    }
    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
}
